import React, { useState, Children, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PopoverContent from './PopoverContent';
import { removeLinkFromText } from '../../../utils/changeEditorLinkFns';
import styles from './Link.module.scss';
import { checkInternalLink } from '../../../../../containers/NewInformations/utils/checkInternalLink';

const Link = ({
  children,
  url,
  setEditorLinkModalData,
  setEditorInformationLinkModalData,
  setEditorState,
  editorStateSelector,
  setEditorPhoneModalData,
}) => {
  const dispatch = useDispatch();
  const editorState = useSelector(editorStateSelector);

  const containerRef = useRef();

  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleDeleteBtnClick = () => {
    const newEditorState = removeLinkFromText({ editorState });
    dispatch(setEditorState(newEditorState));
  };

  const handleEditBtnClick = () => {
    const text = Children.map(children, (child) => child.props.text).join('');

    url.includes('tel')
      ? dispatch(
          setEditorPhoneModalData({
            visible: true,
            phone: url.includes('p')
              ? url.slice(4, url.indexOf('p'))
              : url.slice(4),
            dopPhone: url.includes('p') ? url.slice(url.indexOf('p') + 1) : '',
            text,
            editMode: true,
          })
        )
      : url.includes('/app') &&
        typeof setEditorInformationLinkModalData === 'function'
      ? setEditorInformationLinkModalData({
          visible: true,
          url,
          text,
          editMode: true,
          internalLinkId: checkInternalLink(url),
        })
      : dispatch(
          setEditorLinkModalData({
            visible: true,
            url,
            text,
            editMode: true,
          })
        );
    setPopoverVisible(false);
  };

  const handlePopoverClose = () => {
    setPopoverVisible(false);
  };

  const handleLinkClick = (e) => {
    e.preventDefault();

    if (!popoverVisible) {
      setPopoverVisible(true);
    }
  };

  return (
    <div
      className={styles.root}
      ref={containerRef}
    >
      <a
        href="#"
        onClick={handleLinkClick}
      >
        {children}
      </a>
      {popoverVisible && (
        <PopoverContent
          url={url}
          onEditBtnClick={handleEditBtnClick}
          onDeleteBtnClick={handleDeleteBtnClick}
          onClose={handlePopoverClose}
          parentRef={containerRef}
        />
      )}
    </div>
  );
};

export default Link;
